import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { Flip } from "gsap/Flip";
import { CustomEase } from "gsap/CustomEase";
import { CustomWiggle } from "gsap/CustomWiggle";
import { prefersReducedMotion } from "@/utils/media";

gsap.registerPlugin(
  ScrollTrigger,
  Draggable,
  InertiaPlugin,
  Flip,
  CustomEase,
  CustomWiggle,
);

const defaults = {
  ease: "expo.out",
  duration: 1.2,
};

gsap.defaults(defaults);

const reduced = prefersReducedMotion();

export default gsap;
export {
  defaults,
  reduced,
  ScrollTrigger,
  SplitText,
  Draggable,
  InertiaPlugin,
  Flip,
  CustomEase,
  CustomWiggle,
};
